export default __webpack_public_path__ + "static/media/b3.62c1a69c.svg";